import React, { useState, useEffect } from "react";
import apiClient from "../http-common";
import ScriptShow from "./ScriptShow";
import Swal from "sweetalert2";

const devLog =
  "https://eu-west-1.console.aws.amazon.com/cloudwatch/home?region=eu-west-1#logsV2:log-groups/log-group/$252Faws$252Flambda$252Fdev-db-tool-ApiStack-ApiLambdaPOSTrunscript2D04D7E-fYkr5L30tGPk";
const prodLog =
  "https://eu-west-1.console.aws.amazon.com/cloudwatch/home?region=eu-west-1#logsV2:log-groups/log-group/$252Faws$252Flambda$252Fprod-db-tool-ApiStack-ApiLambdaPOSTrunscript2D04D7-Tpy2lzRtRNAq";

const ScriptList = ({ scripts, fetchData, sstEnv }) => {
  const [statusRun, setStatusRun] = useState(false);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusRun]);

  const onScriptSelect = async (script, env, sstEnv) => {
    Swal.fire({
      title: "Do you want to continue?",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        (async () => {
          await apiClient
            .post("/runscript", {
              script: script,
              environment: env,
            })
            .then(() => {
              setStatusRun(true);
              Swal.fire(
                "Success",
                "The script has been run successfully",
                "success"
              );
            })
            .catch((error) => {
              const logs = sstEnv === "dev" ? devLog : prodLog;
              Swal.fire({
                icon: "error",
                title: "Something went wrong...",
                text: error.response.data?.message,
                footer: `<a href=${logs}>What has happened there (check logs)?</a>`,
              });
            });
        })();
        setStatusRun(false);
      }
    });
  };

  const renderedScripts = scripts.map((script) => {
    return (
      <ScriptShow
        onScriptSelect={onScriptSelect}
        key={script[0].script}
        script={script[0]}
        sstEnv={sstEnv}
      />
    );
  });

  return <>{renderedScripts}</>;
};

export default ScriptList;
